import React from "react";
import { Box, P, Loading } from "orcs-design-system";
import { useGoalsExploreContext } from "src/contexts/goalsExploreContext";

const GoalsExplore = () => {
  const { rootObjectives, loading, error } = useGoalsExploreContext();

  if (loading) {
    return (
      <Box p="m" display="flex" justifyContent="center">
        <Loading />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p="m">
        <P color="danger">Error loading objectives: {error.message}</P>
      </Box>
    );
  }

  if (!rootObjectives || rootObjectives.length === 0) {
    return (
      <Box p="m">
        <P>No objectives found</P>
      </Box>
    );
  }

  return (
    <Box p="m">
      <P weight="bold" mb="s">
        Goals Explorer ({rootObjectives.length})
      </P>
      {rootObjectives.map((objective) => (
        <Box key={objective.id} mb="xs">
          <P>{objective.name}</P>
        </Box>
      ))}
    </Box>
  );
};

export default GoalsExplore;
